import "@dune/ui/globals.css";
import { useChooseFirstPassword } from "../../api/mutations/societies.mutations";
import ResetPasswordForm from "../../component/auth/ResetPasswordForm";

export default function ChoosePassword() {
	const { mutate } = useChooseFirstPassword();
	return <ResetPasswordForm onSubmit={(data) => mutate(data)} />;
}
